// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandNumericEntry_container__2CdPJ","label":"BrandNumericEntry_label__1jj-T","entry":"BrandNumericEntry_entry__3VxYD","invalid":"BrandNumericEntry_invalid__360z8"};